{
  "title": "Product park",
  "subtitle": "List of products linked to your companies.",
  "search": "Search a product",
  "tabs": {
    "allProducts": "All products",
    "epi": "PPE",
    "nonEpi": "Non-PPE",
    "requests": "Requests"
  },
  "kpis": {
    "activeProducts": "Active products",
    "averageUsage": "Average usage time",
    "pendingRequests": "Pending requests",
    "acceptedNameplates": "Accepted products"
  },
  "duration": {
    "day": "{value} day",
    "days": "{value} days",
    "month": "{value} month",
    "months": "{value} months",
    "year": "{value} year",
    "years": "{value} years"
  },
  "table": {
    "photo": "Photo",
    "name": "Name",
    "team": "Team",
    "serialNumber": "Serial number",
    "operatingCenter": "Company",
    "usageStart": "Usage start date",
    "usageDuration": "Usage duration",
    "repair": "Repair",
    "control": "Control"
  },
  "detail": {
    "title": "Product park detail",
    "subtitle": "{productName} - {boomerangId}",
    "pictureAlt": "Product image",
    "sections": {
      "productScope": "Product scope",
      "usage": "Usage information",
      "attachments": "Attachments"
    },
    "labels": {
      "boomerangId": "Park identifier",
      "customerInvoiceId": "Customer invoice identifier",
      "keyAccountNetwork": "Key account network",
      "operatingCenter": "Operating center",
      "distributorNetwork": "Distributor network",
      "store": "Store",
      "manufacturer": "Manufacturer",
      "category": "Category",
      "subCategory": "Sub-category",
      "product": "Product",
      "allocationCode": "Allocation code",
      "companyName": "Company",
      "teamName": "Team",
      "purchaseDate": "Purchase date",
      "usageStartDate": "Usage start date",
      "manufacturingDate": "Manufacturing date",
      "serialNumber": "Serial number",
      "usageDuration": "Usage duration"
    },
    "buttons": {
      "nameplateAttachment": "Open nameplate",
      "purchaseInvoiceAttachment": "Open purchase invoice",
      "addPurchaseInvoice": "Add purchase invoice"
    },
    "actions": {
      "repair": "Repair"
    },
    "messages": {
      "updateSuccess": "Product updated.",
      "purchaseInvoiceUpdateSuccess": "Purchase invoice added."
    },
    "purchaseInvoiceModal": {
      "title": "Add purchase invoice",
      "validate": "Add invoice"
    }
  },
  "requestList": {
    "search": "Search a request",
    "statusFilter": "Status",
    "reference": "REQ-{id}",
    "table": {
      "reference": "Reference",
      "operatingCenter": "Company",
      "requester": "Requester",
      "nameplateCount": "Nameplates",
      "status": "Status",
      "createdAt": "Created at"
    },
    "status": {
      "all": "All statuses",
      "DRAFT": "Draft",
      "PENDING": "Pending",
      "AWAITING_INFORMATION": "Awaiting information",
      "APPROVED": "Approved",
      "DENIED": "Denied"
    },
    "deleteModal": {
      "title": "Delete draft",
      "message": "Are you sure you want to delete this draft request? This action cannot be undone."
    },
    "messages": {
      "deleteSuccess": "Draft deleted."
    }
  },
  "requestDetail": {
    "title": "Request detail",
    "subtitle": "Creation request REQ-{id}",
    "sections": {
      "request": "Request information",
      "scope": "Link information",
      "attachments": "Attachments"
    },
    "labels": {
      "reference": "Reference",
      "status": "Status",
      "createdAt": "Created at",
      "reviewedAt": "Reviewed at",
      "keyAccountNetwork": "Key account network",
      "operatingCenter": "Operating center",
      "requester": "Requester",
      "nameplateCount": "Nameplates",
      "purchaseInvoice": "Purchase invoice",
      "nameplates": "Nameplate files"
    }
  },
  "requestDraft": {
    "title": "New creation request",
    "editTitle": "Resume request",
    "publicTitle": "Continue request",
    "subtitle": "Upload the purchase invoice and product nameplates to reference",
    "operatingCenter": {
      "title": "Link information",
      "subtitle": "Select the operating center concerned by this request.",
      "field": "Operating center",
      "placeholder": "Select an operating center"
    },
    "invoice": {
      "title": "Purchase invoice",
      "subtitle": "One file only - PDF or image",
      "dropzoneTitle": "Click or drop your invoice",
      "acceptedFormats": "PDF, JPG, PNG, WEBP"
    },
    "nameplates": {
      "title": "Nameplates",
      "subtitle": "One plate = one product to create (at least 1)",
      "dropzoneTitle": "Add one or more nameplates",
      "acceptedFormats": "JPG, PNG, WEBP, HEIC - you can select several files"
    },
    "dropzone": {
      "dragHere": "Drop your file here",
      "or": "or ",
      "browse": "browse files",
      "acceptedFormats": "Accepted formats"
    },
    "actions": {
      "add": "Add",
      "addFromPhone": "Add from a phone",
      "create": "New request",
      "remove": "Remove",
      "share": "Share with a collaborator",
      "sendFromMobile": "Send from mobile",
      "takePhoto": "Take a photo",
      "submit": "Finalize request"
    },
    "footer": {
      "invoice": "Purchase invoice",
      "nameplates": "{count} nameplate(s)",
      "nameplatesReady": "{count} nameplate(s) ready to send"
    },
    "messages": {
      "createSuccess": "Creation request sent."
    },
    "publicConfirmation": {
      "title": "Request sent",
      "subtitle": "The form has been sent. You can close this page."
    },
    "mobileUpload": {
      "title": "Add from a phone",
      "subtitle": "Scan this QR code with your phone to add one or more nameplates.",
      "help": "Take a photo or add files from your phone, then return to this screen to confirm the upload.",
      "confirm": "I added the nameplate from my phone",
      "missing": "No new nameplate has been added from the phone yet.",
      "publicTitle": "Add nameplates",
      "publicSubtitle": "Take a photo or add one or more nameplates from your phone.",
      "publicSubmit": "Add nameplates",
      "successTitle": "Nameplates added",
      "successSubtitle": "The nameplates have been added. You can resume the request on the computer."
    },
    "share": {
      "title": "Share the form",
      "subtitle": "Send this form to someone so they can fill it in for you.",
      "scanTitle": "Scan with a mobile",
      "scanHelp": "Opens the form directly on the phone.",
      "copyTitle": "Copy the link",
      "emailTitle": "Send by email",
      "smsTitle": "Send by SMS",
      "linkLabel": "Resume link",
      "copySuccess": "Link copied.",
      "copyError": "Unable to copy link.",
      "emailLabel": "Email address",
      "emailPlaceholder": "Email address",
      "emailButton": "Send",
      "emailSuccess": "Link sent by email.",
      "emailError": "Unable to send email.",
      "smsLabel": "Phone",
      "smsPlaceholder": "Phone",
      "smsButton": "Send",
      "smsSuccess": "Link sent by SMS.",
      "smsError": "Unable to send SMS."
    }
  }
}
